import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
const loadedLanguages = [];

const dateTimeFormats = {
  en: {
    "date-short": {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    "date-long": {
      year: "numeric",
      month: "long",
      day: "numeric"
    },
    "date-time": {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }
  },
  da: {
    "date-short": {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    "date-long": {
      day: "numeric",
      month: "long",
      year: "numeric"
    },
    "date-time": {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }
  },
  de: {
    "date-short": {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    },
    "date-long": {
      day: "numeric",
      month: "long",
      year: "numeric"
    }
  }
};

/**
 * Export i18n instance
 */
export const i18n = new VueI18n({
  locale: import.meta.env.VITE_APP_I18N_LOCALE || "da",
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || "da",
  messages: {}, // set locale messages
  dateTimeFormats
});

/**
 * Sets the language for the website
 * @param { string } lang Locale language code
 * @returns { string } Local language code
 */
function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

/**
 * Loads the language asynchronously
 * @param { string } language Locale language code
 * @param { string } languageVariant Variant of language - eg skole, dagtilbud, nwp
 * @param { string } customerFile Customer specific file name
 * @returns { Promise } Promise
 */
export async function loadLanguageAsync(language, languageVariant, customerFile) {
  // If the same language
  if (i18n.locale === language) {
    setI18nLanguage(language);
  }

  // If the language was already loaded
  if (loadedLanguages.includes(language)) {
    return Promise.resolve(setI18nLanguage(language));
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `../../locales/${language}-${languageVariant}.json`).then(
    translations => {
      let translationData = translations.default;
      if (customerFile) {
        import(
          /* webpackChunkName: "lang-[request]" */ `../../locales/customerspecific/${language}-${customerFile}.json`
        )
          .then(customerSpecificTranslations => {
            translationData = {
              ...translations.default,
              ...customerSpecificTranslations.default // Merge translations
            };

            i18n.setLocaleMessage(language, translationData);
            loadedLanguages.push(language);
            return setI18nLanguage(language);
          })
          .catch(() => {
            i18n.setLocaleMessage(language, translationData);
            loadedLanguages.push(language);
            return setI18nLanguage(language);
          });
      } else {
        i18n.setLocaleMessage(language, translationData);
        loadedLanguages.push(language);
        return setI18nLanguage(language);
      }
    }
  );
}
